import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { RiDashboardLine } from "react-icons/ri";
import { FaCogs, FaBullhorn } from "react-icons/fa";
import { MdOutlineVolunteerActivism } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import {
  HiOutlineUserGroup,
  HiOutlineChartBar,
  HiOutlineEnvelope,
} from "react-icons/hi2";
import { TbListDetails, TbSlideshow } from "react-icons/tb";
import { LuUsers, LuGalleryHorizontal, LuQuote } from "react-icons/lu";
import { RiGlobalLine } from "react-icons/ri";

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // const menuItems = [
  //   {
  //     label: "Dashboard",
  //     icon: <RiDashboardLine size={20} />,
  //     path: "/dashboard",
  //   },
  //   {
  //     label: "Campaign",
  //     icon: <FaBullhorn size={18} />,
  //     path: "/admin-campaign",
  //   },
  //   {
  //     label: "Services",
  //     icon: <FaCogs size={18} />,
  //     path: "/admin-programmes",
  //   },
  //   {
  //     label: "Banners",
  //     icon: <TbListDetails size={18} />,
  //     path: "/admin-banners",
  //   },
  //   {
  //     label: "Blogs",
  //     icon: <TbListDetails size={18} />,
  //     path: "/admin-blogs",
  //   },
  //   {
  //     label: "Gallery",
  //     icon: <MdPhotoLibrary size={18} />,
  //     path: "/admin-gallery",
  //   },
  //   {
  //     label: "Testimonials",
  //     icon: <FaQuoteRight size={18} />,
  //     path: "/admin-testimonials",
  //   },
  //   {
  //     label: "Certifications",
  //     icon: <FaAward size={18} />,
  //     path: "/admin-certificates",
  //   },
  //   {
  //     label: "Volunteers",
  //     icon: <MdVolunteerActivism size={18} />,
  //     path: "/admin-volunteers",
  //   },
  //   {
  //     label: "Our Team",
  //     icon: <HiOutlineUserGroup size={18} />,
  //     path: "/admin-teams",
  //   },
  //   {
  //     label: "Interventions Stats",
  //     icon: <HiOutlineChartBar size={18} />,
  //     path: "/admin-interventions",
  //   },
  //   {
  //     label: "Contacts",
  //     icon: <HiOutlineEnvelope size={18} />,
  //     path: "/admin-contacts",
  //   },
  //   {
  //     label: "Partners",
  //     icon: <LuUsers size={18} />,
  //     path: "/admin-partners",
  //   },
  //   {
  //     label: "Sustainable D. Goals",
  //     icon: <LuUsers size={18} />,
  //     path: "/admin-sdgs",
  //   },
  // ];

  const [openMenu, setOpenMenu] = React.useState(null);

  const menuItems = [
    {
      label: "Dashboard",
      icon: <RiDashboardLine size={20} />,
      path: "/dashboard",
    },
    {
      label: "Campaign",
      icon: <FaBullhorn size={18} />,
      children: [
        {
          label: "Featured Campaign",
          path: "/featured-campaign",
        },
        {
          label: "Special Campaign",
          path: "/special-campaign",
        },
      ],
    },
    {
      label: "Programmes",
      icon: <FaCogs size={18} />,
      path: "/admin-programmes",
    },
    {
      label: "Banners",
      icon: <TbSlideshow size={18} />,
      path: "/admin-banners",
    },
    {
      label: "Blogs",
      icon: <TbListDetails size={18} />,
      path: "/admin-blogs",
    },

    {
      label: "Gallery",
      icon: <LuGalleryHorizontal size={18} />,
      path: "/admin-gallery",
    },
    {
      label: "Testimonials",
      icon: <LuQuote size={18} />,
      path: "/admin-testimonials",
    },
    {
      label: "Volunteers",
      icon: <MdOutlineVolunteerActivism size={18} />,
      children: [
        {
          label: "Web",
          path: "/admin-volunteers",
        },
        {
          label: "App",
          path: "/admin-volunteers-v2",
        },
      ],
    },

    {
      label: "Our Team",
      icon: <HiOutlineUserGroup size={18} />,
      path: "/admin-teams",
    },
    {
      label: "Partners",
      icon: <LuUsers size={18} />,
      path: "/admin-partners",
    },

    {
      label: "Sustainable D. Goals",
      icon: <RiGlobalLine size={18} />,
      path: "/admin-sdgs",
    },

    {
      label: "Interventions Stats",
      icon: <HiOutlineChartBar size={18} />,
      path: "/admin-interventions",
    },
    {
      label: "Contacts",
      icon: <HiOutlineEnvelope size={18} />,
      path: "/admin-contacts",
    },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    // Close mobile sidebar after navigation
    if (window.innerWidth < 1024) {
      setIsSidebarOpen(false);
    }
  };

  const renderMenuItems = () => (
    <nav className="flex-1 px-4 ">
      <ul className="space-y-1">
        {menuItems.map((item) => (
          <li key={item.label}>
            {/* Parent Item */}
            <button
              onClick={() => {
                if (item.children) {
                  setOpenMenu(openMenu === item.label ? null : item.label);
                } else {
                  handleNavigation(item.path);
                }
              }}
              className={`w-full flex items-center justify-between px-4 py-3 text-sm font-medium rounded-lg transition-all duration-200
  ${
    location.pathname === item.path
      ? "bg-primaryColor text-white"
      : "text-primaryTextColor hover:bg-gray-100"
  }
`}
            >
              <div className="flex items-center">
                <span className="mr-3 text-gray-500">{item.icon}</span>
                {item.label}
              </div>

              {/* Dropdown arrow */}
              {item.children && (
                <span>{openMenu === item.label ? "▲" : "▼"}</span>
              )}
            </button>

            {/* Submenu */}
            {item.children && openMenu === item.label && (
              <ul className="ml-8 mt-1 space-y-1">
                {item.children.map((sub) => (
                  <li key={sub.path}>
                    <button
                      onClick={() => handleNavigation(sub.path)}
                      className={`w-full text-left px-4 py-2 text-sm rounded-md ${
                        location.pathname === sub.path
                          ? "bg-primaryColor text-white"
                          : "text-gray-600 hover:bg-gray-100"
                      }`}
                    >
                      {sub.label}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );

  return (
    <React.Fragment>
      {/* Desktop Sidebar */}
      <div className="hidden lg:flex lg:w-60 lg:flex-col lg:fixed lg:inset-y-0 lg:pt-16 lg:bg-white lg:border-r lg:border-gray-200 lg:shadow-sm">
        {renderMenuItems()}
      </div>

      {/* Mobile Sidebar */}
      <AnimatePresence>
        {isSidebarOpen && (
          <>
            {/* Backdrop - Click outside to close */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="lg:hidden fixed inset-0 z-40 bg-black bg-opacity-50"
              onClick={() => setIsSidebarOpen(false)}
            />

            {/* Mobile Sidebar Panel */}
            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{
                duration: 0.3,
                ease: [0.4, 0.0, 0.2, 1], // Custom easing for smooth animation
              }}
              className="lg:hidden fixed inset-y-0 left-0 z-50 w-72 bg-white shadow-2xl flex flex-col  "
            >
              <div className="px-4 flex items-center w-full py-4 border-b border-gray-200">
                <button
                  onClick={() => setIsSidebarOpen(false)}
                  className="lg:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors duration-200"
                >
                  <IoClose size={24} />
                </button>
                {/* Sidebar Header */}
                <h2 className="text-lg font-semibold text-primaryTextColor">
                  Navigation
                </h2>
              </div>

              {/* Menu Items */}
              {renderMenuItems()}

              {/* Footer */}
              <div className="px-4 py-4 mt-auto border-t border-gray-200">
                <p className="text-xs text-gray-500 text-center">
                  Admin Dashboard v1.0
                </p>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </React.Fragment>
  );
};

export default Sidebar;
